import { cn } from "@devhop/ui";
import { useMemo } from "react";
import {
  computeLineItemsQtyByUnit,
  type LineItemQtyInput,
} from "../lib/line-items-qty-by-unit";

type DocumentLineQtyByUnitSummaryProps = {
  items: LineItemQtyInput[];
  className?: string;
};

/** ສະຫຼຸບ qty ຕາມຫນ່ວຍ — ສຳລັບຜູ້ໃຊ້ເບິ່ງເທົ່ານັ້ນ, ບໍ່ລວມໃນ PDF/print */
export function DocumentLineQtyByUnitSummary({
  items,
  className,
}: DocumentLineQtyByUnitSummaryProps) {
  const rows = useMemo(() => computeLineItemsQtyByUnit(items), [items]);

  if (rows.length === 0) return null;

  return (
    <div
      className={cn(
        "rounded-lg border border-dashed bg-muted/30 p-4 print:hidden",
        className,
      )}
      data-testid="document-qty-by-unit-summary"
    >
      <p className="font-medium text-sm">ສະຫຼຸບຈຳນວນຕາມຫນ່ວຍ</p>
      <p className="mt-0.5 text-muted-foreground text-xs">
        ສຳລັບອ້າງອີງພາຍໃນ — ບໍ່ລວມໃນເອກະສານທີ່ພິມ
      </p>
      <ul className="mt-3 flex flex-wrap gap-2">
        {rows.map((row) => (
          <li
            key={row.unit}
            className="inline-flex items-center gap-2 rounded-md border bg-background px-3 py-1.5 text-sm"
          >
            <span className="font-semibold tabular-nums">
              {row.quantity.toLocaleString()}
            </span>
            <span className="text-muted-foreground">{row.unit}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
